import { useContext } from 'react';

import { AccountsInfoContext } from 'providers/AccountsInfoProvider';

const useAccountsInfo = () => {
  const accountsInfo = useContext(AccountsInfoContext);
  return accountsInfo;
};

export default useAccountsInfo;
